import { Typography } from '@material-ui/core'

import { lang } from '../../../../localization'
import { RoomStay } from '../../../../types/bookingDetails'

// The BFF field resolver and Adotel both require the verified IAM admin claim.
// A normal booking reader receives null, not a diagnostic hidden with CSS.
export default function FailureDetails({ room }: { room?: RoomStay }) {
  if (!room?.technicalFailure) return null
  const diagnostic = room.technicalFailure

  return (
    <>
      <Typography variant="subtitle1">
        {lang === 'fa'
          ? 'جزئیات فنی خطای PMS'
          : 'PMS technical failure details'}
      </Typography>
      <Typography
        variant="body2"
        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
        {diagnostic.message}
      </Typography>
      <Typography variant="caption" dir="ltr">
        {room.failureReasonCode || 'UNKNOWN'} ·{' '}
        {lang === 'fa' ? 'دسته' : 'Category'}: {diagnostic.categoryCode ?? '—'}{' '}
        · {lang === 'fa' ? 'کد PMS' : 'PMS code'}:{' '}
        {diagnostic.providerCode ?? '—'} · HTTP: {diagnostic.httpStatus ?? '—'}
      </Typography>
    </>
  )
}
